import { ErrorBoundaryHoc } from "@components/boundary/ErrorBoundaryHoc";
import { RegistrationStoreContext } from "@state/context/membership/registration-types/RegistrationStoreContext";
import { logger } from "@utils/logger/logger";
import { useContext, useEffect } from "react";

export default ErrorBoundaryHoc(ErrorWrapper);

function ErrorWrapper(props: { error: Error | string; componentName: string }) {
	const store = useContext(RegistrationStoreContext);
	useEffect(() => {
		if (store) {
			store.setIsRegistrationSuccessful(false);
		}
		logger.logError(props.error, {
			extra: { gp_location: props.componentName },
		});
	}, []);
	return null;
}
